import React, { useCallback } from 'react';
import useSWR, { mutate } from 'swr';
import { ReactComponent as BulbOnIcon } from 'assets/icons/light-bulb-on.svg';
import { ReactComponent as BulbOffIcon } from 'assets/icons/light-bulb-off.svg';
import { availableToggleStyles } from './styled';
import Tippy from '@tippyjs/react';
import cx from 'classnames';
import { toggleAvailability, AVAILABLE_TOOGLE_URL } from 'modules/agent-availability/http';
import { useSelector } from 'react-redux';
import { get } from 'utils/http';

const t = {
  activate: 'Set yourself as available',
  deactivate: 'Set yourself as unavailable',
};

const AvailableToggle = ({ className }) => {
  const me = useSelector((state) => state.me);
  const URL = `${AVAILABLE_TOOGLE_URL}${me.id}/`;

  const { data: userData } = useSWR(me.id ? URL : null, get, { revalidateOnFocus: true });

  const handleClick = useCallback(async () => {
    const updatedUserData = await toggleAvailability(userData);

    mutate(URL, updatedUserData, false);
  }, [userData, URL]);

  return (
    <Tippy
      interactive
      maxWidth="none"
      content={<span>{userData?.available ? t.deactivate : t.activate}</span>}
    >
      <div
        onClick={handleClick}
        className={cx(className, { 'availableToggle--active': userData?.available })}
        data-testid="availableToggle"
      >
        {userData?.available ? <BulbOnIcon /> : <BulbOffIcon />}
      </div>
    </Tippy>
  );
};

export default availableToggleStyles(AvailableToggle);
